import { filter } from "lodash";
// import { sentenceCase } from 'change-case';
import { useEffect, useState } from "react";
// import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Stack,
  Container,
  Typography,
  Button,
  MenuItem,
  CircularProgress,
  Select,
  Tabs,
  Tab,
  Checkbox,
} from "@mui/material";
// components
import Page from "../../../components/Page";

// import Scrollbar from "../../../components/Scrollbar";

// import SearchNotFound from "../../../components/SearchNotFound";
// import { UserListHead, UserListToolbar, UserMoreMenu } from "../user";
// mock
// importusers ? from '../_mock/user';
import { useNavigate, useParams } from "react-router-dom";
import SyncLoader from "react-spinners/SyncLoader";
//mui icons
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./quiz.css";

import { MathJax } from "better-react-mathjax";
// import { useHistory } from 'react-router-dom';
// ------------------------------------------------
const token = localStorage.getItem("token");
export default function QuizTable() {

  const detailObject = JSON.parse(localStorage.getItem("detailObject"));
  const accessArr = detailObject?.access_level?.split(',');
  const role = localStorage.getItem('role');
  const access = JSON.parse(localStorage.getItem("detailObject"));

  const [formData, setFormData] = useState({
    question_e: "",
    question_h: "",
    option1_e: "",
    option2_e: "",
    option3_e: "",
    option4_e: "",
    option1_h: "",
    option2_h: "",
    option3_h: "",
    option4_h: "",
    difficulty_level: "",
    correctAns: "",
    answer_e: "",
    answer_h: "",
  });

  //const [questionSelected, setQuestionSelected] = useState(null);
  const [questionsList, setQuestionsList] = useState(null);
  const [testMetaData, setTestMetaData] = useState(null);
  const navigate = useNavigate();
  const [users, usersSet] = useState();
  const [template_id, setTemplate_id] = useState("0");
  const [loading, setLoading] = useState(false);
  const [selectedSubject, setSelectedSubject] = useState();
  const [subjectList, setSubjectList] = useState();
  const [subjectName, setSubjectName] = useState();
  const [options, setOptions] = useState([]);
  //Getting Id and Name Of quiz
  const [count, setCout] = useState(0)
  const { quizId, quizTitle } = useParams();

  const [updatedQuestion, setupdatedQuestion] = useState({});

  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const [questionSelected, setQuestionSelected] = useState(null);



  const handleCheckboxChange = (question) => {
    setSelectedQuestions((prevSelected) => {
      const isSelected = prevSelected.includes(question.question_id);
      if (isSelected) {
        // Remove from selected if already selected
        return prevSelected.filter((id) => id !== question.question_id);
      } else {
        // Add to selected if not already selected
        return [...prevSelected, question.question_id];
      }
    });
  };


  async function f() {
    if (!quizId || !selectedSubject) return;
    const questions = await axios.get(
      `${process.env.REACT_APP_LIVE_URL_NEW}/admin/get-test?subject_id=${selectedSubject}&test_id=${quizId}&subject_template_id=${template_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log("get test subject id vala ", questions);
    setQuestionsList(questions?.data?.data?.questions || []);
    setQuestionSelected(questions?.data?.data?.questions[0]);

    sessionStorage.setItem(
      quizId,
      JSON.stringify(questions?.data?.data?.questions)
    );
    toast.success("Questions fetched successfully.",{position:"bottom-right"});
  }
  const fetchOptions = async () => {
    // const token = localStorage.getItem("token");
    const authToken = token;
    const headers = {
      "content-type": "application/json",
      Authorization: `Bearer ${authToken}`,
    };
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_LIVE_URL_NEW}/admin/mock-test-template-subjects-by-id/${template_id}`,
        { headers }
      );
      // setOptions(response.data.data);
      setSubjectList(response.data.data);
      setSelectedSubject(response.data.data[0].id);
      //  setSubjectName(response.data.data[0].subject_name);
      setSubjectName(response.data.data[0].name);
      toast.success("Subject fetched successfully.",{position:"bottom-right"});
    } catch (error) {
      console.error("Error fetching options:", error);
    }
  };

  const handleBulkDelete = async () => {


    // const token = localStorage.getItem("token");
    const ids = selectedQuestions;
  
    const requestBody = {
      question_id: ids,
      subject_id: selectedSubject,
      test_id: Number(quizId),
      subject_template_id: template_id,
      type: "test",
    };

    // setLoading(true);
    try {
      await axios.delete(
        `${process.env.REACT_APP_LIVE_URL_NEW}/admin/remove-questions`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          data: requestBody,
        }
      );
      setQuestionsList((prev) =>
        prev.filter((q) => !selectedQuestions.includes(q.question_id))
      );
      setSelectedQuestions([]);
      fetchOptions();
      f();
     toast.success("Questions deleted successfully.",{position:"bottom-right"});

    } catch (error) {
      console.error("Error deleting questions:", error);
      alert("Failed to delete questions.");
    }
    setLoading(false);
  };


 

  const handelInput = (e) => {
    const { name, value } = e.target;

    setupdatedQuestion({
      ...updatedQuestion,
      [name]: value,
    });
  };

  useEffect(() => {
    sessionStorage.clear();
    // const token = localStorage.getItem("token");
    async function fetchUsers() {
      try {
        setLoading(true);
        if (
          sessionStorage.getItem(quizId) &&
          sessionStorage.getItem(`metadata_${quizId}`)
        ) {
          const questions = JSON.parse(sessionStorage.getItem(quizId));
          const metadata = JSON.parse(
            sessionStorage.getItem(`metadata_${quizId}`)
          );
          console.log("metadata", metadata);
          setQuestionsList(questions);
          setTestMetaData(metadata);
          setDropdownValue(responseJson?.data?.test.subjects[0].id);
          setQuestionSelected(questions[0]);
          setOptions(responseJson?.data?.test.subjects);
          // setSubjectList(metadata?.subject_id);
          console.log("Options :  ", options);
          setTemplate_id(responseJson?.data?.test.subjects[0].id);
          if (
            Array.isArray(metadata?.subject_id) &&
            metadata?.subject_id?.length > 0
          ) {
            // setSelectedSubject(metadata?.subject_id[0].id);
            // setSubjectName(metadata?.subject_id[0].name);
          }
          setLoading(false);
        }
        const fullResponse = await fetch(
          `${process.env.REACT_APP_LIVE_URL_NEW}/admin/get-test-by-id/${quizId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const responseJson = await fullResponse.json();
        console.log(
          "THis has to be the responseJson:::",
          responseJson.data?.test.subjects
        );
        const subjectIds = responseJson?.data?.test.subject_id;
        setOptions(responseJson?.data?.test.subjects);
        setDropdownValue(responseJson?.data?.test.subjects[0].id);
        setTemplate_id(responseJson?.data?.test.subjects[0].id);
        if (Array.isArray(subjectIds) && subjectIds.length > 0) {
          setSelectedSubject(subjectIds[0].id);
        }

        // console.log(responseJson)
        // setSubjectList(subjectIds);

        //! temperorily commented
        // const questions = await axios.post(`https://invictaa.com/app-api/api/frontend/get-quiz-question-by-id`, {
        //   "questionId":responseJson?.data?.questionId
        // })

        // console.log("This has to be the Questions List data ::::::", questions)

        setTestMetaData(responseJson?.data?.test);

        sessionStorage.setItem(
          `metadata_${quizId}`,
          JSON.stringify(responseJson?.data?.test || [])
        );
        setLoading(false);
      } catch (error) {
        console.log("Error :: ", error);
        setLoading(false);
      }
      // addDetails(responseJson.data)
    }

    fetchUsers();
  }, []);

  useEffect(() => {
    
  

    // fetchOptions();
    f();

    // return () => {
    //   // setSelectedSubject();
    // };
  }, [selectedSubject]);


  useEffect(() => {
   
    fetchOptions();
  }, [template_id]);

  // //console.log(quizD)
  console.log("Option Value ", options);
  const [selectedIdOfQuestion, setSelectedIdOfQuestion] = useState("");
  const [selectedIdOfQuestionOnHover, setSelectedIdOfQuestionOnHover] =
    useState("");
   const [dropdownValue, setDropdownValue] = useState("");
  const [deleteDisplay, setDeleteDisplay] = useState(false);
  const handleDropdownChange = (event) => {
    setDropdownValue(event.target.value);
    setTemplate_id(event.target.value);
  };

  //Update

  // uploading excel file for bulk question import
  const handleUploadExcel = () => {
    document.getElementById("fileInput").click();
    document.querySelector(".mainDiv").style.display = "block";
    setProgress(0);
  };

  const [progress, setProgress] = useState();

  const handleFileUpload = async (event) => {
    const file1 = event.target.files[0];
    // const token = localStorage.getItem("token");
    const authToken = token;
    const config = {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      onUploadProgress: (data) => {
        //Set the progress value to show the progress bar
        setProgress(Math.round((100 * data.loaded) / data.total));
      },
    };
    const formData = new FormData();
    formData.append("file", file1);

    setTimeout(() => window.location.reload(), 3000);
  };

  const [language, setLanguage] = useState(false);


  const handleChange = (newValue) => {
    setLoading(true); // Start loading when subject changes
    setSelectedSubject(newValue);

    // Simulate data fetching or processing
    setTimeout(() => {
      setSubjectName(subjectList.filter((sub) => sub.id === newValue)[0].name);
      setLoading(false); // Stop loading once data is ready
    }, 1000); // Adjust the delay as needed
  };


  return (
    <>
      {loading ? (
        <Stack
          justifyContent="center"
          alignItems="center"
          sx={{ height: "70vh" }}
        >
          <SyncLoader color="#8080ff" loading={loading} size={20} />
        </Stack>
      ) : (
        <Page title="Quiz Questions">
          <Container sx={{ position: "absolute", minWidth: "100%" }}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              mb={3}
            >
              <Typography variant="h3" gutterBottom>
                {quizTitle} Questions {` - (${count})`}
              </Typography>
            

              <input
                type="file"
                id="fileInput"
                accept=".xlsx, .xls"
                onChange={handleFileUpload}
                style={{ display: "none" }}
              />
            </Stack>
            <div className="mainDiv">
              <div className="childDiv" style={{ width: `${progress}%` }}>
                <span>{progress}% </span>
              </div>
            </div>
            <Stack
              direction="row"
              mb={2}
              sx={{
                boxShadow: "0px 0px 17px #BFBFBF",
                borderRadius: "15px",
                height: "100%",
                background: "#E6E6FF",
              }}
            >
              <Stack
                direction="column"
                sx={{
                  flex: 0.5,
                  height: "100%",
                  bgcolor: "#E6E6FF",
                  color: "black",
                  borderRadius: "15px 0px 0px 15px",
                }}
              >
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  p={2}
                  sx={{
                    width: "100%",
                    //  borderRight: "2px solid  #8080ff",
                  }}
                >
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <svg
                      width="32"
                      height="28"
                      viewBox="0 0 32 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0 16.8H3.55556V11.2H0V16.8ZM0 28H3.55556V22.4H0V28ZM0 5.6H3.55556V0H0V5.6ZM7.11111 16.8H32V11.2H7.11111V16.8ZM7.11111 28H32V22.4H7.11111V28ZM7.11111 0V5.6H32V0H7.11111Z"
                        fill="black"
                      />
                    </svg>
                    <Typography color="black" sx={{ fontSize: "18px" }}>
                      {testMetaData?.No_of_questions} Questions
                    </Typography>
                  </Stack>
                  {(role=='Admin' ||
                   accessArr?.includes("write")) && (
                      <Stack direction="row">
                        <Button
                          p={3}
                          sx={{
                            bgcolor: "#e6e6ff",
                            color: "black",
                            borderRadius: "50px",
                            "&:hover": { background: " #8080ff" },
                          }}
                          onClick={() => {
                            sessionStorage.clear();
                            navigate(
                              `/dashboard/addQuizQuestion/${quizTitle}/${quizId}?testseriesId=${testMetaData?.testseries_id}&template_id=${template_id}&subName=${subjectName}&subId=${selectedSubject}`
                            );
                            // setAddQuizSelected(true)
                          }}
                        >
                          + Add Question
                        </Button>
                      </Stack>
                    )}

                  <Typography>{deleteDisplay}</Typography>
                </Stack>
                <Stack
                  direction={"row"}
                  spacing={2}
                  justifyContent={"start"}
                  width={"30rem"}
                  overflow={"scroll"}
                  paddingBottom="1rem"
                  sx={{
                    borderRight: "2px solid #8080ff",
                  }}
                >
                  <Tabs
                    value={selectedSubject}
                    onChange={(e, newValue) => handleChange(newValue)}
                    variant="scrollable"
                    aria-label="scrollable auto tabs example"
                    scrollButtons
                    allowScrollButtonsMobile
                  >
                    {subjectList?.map((sub) => (
                      <Tab
                        label={`${sub?.name} (${sub?.count || 0})`}
                        key={sub.id}
                        value={sub.id}
                      />
                    ))}
                  </Tabs>

                  {loading && (
                    <CircularProgress
                      size={24}
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        marginLeft: "-12px",
                        marginTop: "-12px",
                      }}
                    />
                  )}
                </Stack>

                <div>
             
                   {selectedQuestions.length>0&&   <Button
                        variant="contained"
                        size="small"
                        sx={{
                          background: "#e6e6ff",
                          color: "black",
                          "&:hover": { background: "#FF0000" },
                          padding: "4px 8px",
                          fontSize: "0.75rem",
                          marginBottom: "10px",
                          display: "block",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                        onClick={handleBulkDelete}
                      >
                        Delete Selected
                      </Button>
}
                  {/* Delete Selected Button positioned at the top */}
                  {/* {(role=='Admin'&&accessArr?.includes('delete'))&&Array.isArray(selectedQuestions) &&
                    selectedQuestions.length > 0 && (
                      <Button
                        variant="contained"
                        size="small"
                        sx={{
                          background: "#e6e6ff",
                          color: "black",
                          "&:hover": { background: "#FF0000" },
                          padding: "4px 8px",
                          fontSize: "0.75rem",
                          marginBottom: "10px",
                          display: "block",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                        onClick={handleBulkDelete}
                      >
                        Delete Selected
                      </Button>
                    )} */}

                  <Stack
                    direction="column"
                    sx={{
                      width: "100%",
                      height: "calc(100vh - 50px)", // Adjust height to accommodate the button
                      borderRight: "2px solid #8080ff",
                      maxHeight: "fit-content",
                      overflowY: "scroll",
                      borderBottomLeftRadius: "15px",
                      background: "#E6E6FF",
                    }}
                  >
                    {questionsList ? (
                      questionsList.length === 0 ? (
                        <h3
                          style={{
                            width: "full",
                            justifyContent: "center",
                            display: "flex",
                          }}
                        >
                          No Questions
                        </h3>
                      ) : (
                        questionsList.map((questionData, index) => (
                          <Stack
                            spacing={2}
                            p={2}
                            direction="row"
                            style={{
                              cursor: "pointer",
                              backgroundColor:
                                questionSelected === questionData
                                  ? "whitesmoke"
                                  : "transparent",
                              transition: "background-color 0.3s",
                            }}
                            key={questionData?.question_id}
                            onClick={() => setQuestionSelected(questionData)}
                          >
                          {
                            (role=='Admin'||accessArr?.includes('delete'))&&
                            <Checkbox
                              checked={
                                Array.isArray(selectedQuestions) &&
                                selectedQuestions.includes(
                                  questionData.question_id
                                )
                              }
                              onChange={() =>
                                handleCheckboxChange(questionData)
                              }
                            />
                          }
                            <div style={{ paddingTop: "0.55rem" }}>
                              {index + 1}){" "}
                            </div>
                            <div
                              fontSize="10px"
                              margin="0.5rem"
                              style={{ padding: "0 0.45rem" }}
                            >
                              <MathJax>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: questionData?.question_title,
                                  }}
                                ></div>
                              </MathJax>
                            </div>
                          </Stack>
                        ))
                      )
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          marginTop: "3rem",
                        }}
                      >
                        <CircularProgress
                          size={50}
                          style={{ marginInline: "auto" }}
                        />
                      </div>
                    )}
                  </Stack>
                </div>
              </Stack>
              <Stack
                direction="column"
                spacing={2}
                sx={{
                  flex: 1,
                  height: "110vh",
                  overflowY: "scroll",
                  bgcolor: "#E6E6FF",
                  borderRadius: "0px 15px 15px 0px",
                }}
              >
                <Stack
                  direction="row"
                  p={1.5}
                  alignItems="center"
                  sx={{
                    width: "100%",
                    borderBottom: 1,
                    borderColor: "lightgray",
                  }}
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="flex-start"
                    spacing={2}
                    sx={{ flex: 1 }}
                  >
                    <Select
                      value={template_id}
                      onChange={handleDropdownChange}
                      displayEmpty
                      sx={{
                        flex: 1,
                        bgcolor: "#e6e6ff",
                        color: "black",
                        borderRadius: "15px",
                        "& .MuiSelect-select": {
                          padding: "8px 16px",
                        },
                      }}
                    >
                      {options?.map((option) => (
                        <MenuItem key={option?.id} value={option?.id}>
                          {option?.subject_name}
                        </MenuItem>
                      ))}
                    </Select>
                    <Typography
                      p={1}
                      px={2}
                      sx={{
                        background: "#807FFF",
                        color: "white",
                        borderRadius: "25px",
                        cursor: "pointer",
                      }}
                    >
                      Duration :{testMetaData?.duration} min
                    </Typography>
                  </Stack>
                  <Stack
                    direction="row"
                    justifyContent="center"
                    sx={{ flex: 1 }}
                  >
                    <Typography
                      p={1}
                      px={2}
                      sx={{
                        color: "white",
                        background: "#807FFF",
                        borderRadius: "25px",
                        cursor: "pointer",
                      }}
                    >
                      Marks per question : {testMetaData?.eachQuestionMarks}
                    </Typography>
                  </Stack>
                </Stack>

                {questionSelected ? (
                  <Stack
                    fontSize={"0.9rem"}
                    spacing={1}
                    style={{ width: "45vw", marginLeft: "1.2rem" }}
                  >
                    <Stack style={{ display: "flex", marginBottom: "1rem" }}>
                      <MathJax>
                        <Stack direction="row" spacing={3}>
                          <div style={{ display: "flex" }}>
                            <b>Question:</b>
                          </div>
                          <p
                            className="text-lg"
                            style={{
                              display: "inline",
                            }}
                            dangerouslySetInnerHTML={{
                              __html: questionSelected?.question_title,
                            }}
                          ></p>
                        </Stack>
                      </MathJax>
                    </Stack>

                    <MathJax>
                      <Stack
                        className="Options"
                        direction={"column"}
                        marginY={"2rem"}
                        spacing={3}
                      >
                        <Stack direction="row" spacing={1}>
                          <strong style={{ margin: "0.5rem" }}>Options:</strong>
                          <Stack spacing={4} direction="row" flexWrap={"wrap"}>
                            {questionSelected?.options.map((option, index) => (
                              <div
                                key={index}
                                style={{
                                  width: "14rem",
                                  padding: "1rem",
                                  margin: "0.5rem",
                                  background: "white",
                                  borderRadius: "5px",
                                  height: "fit-content",
                                  minHeight: "5rem",
                                  boxShadow: "0px 0px 17px #807FFF",
                                }}
                              >
                                {String.fromCharCode(96 + index + 1)}) &nbsp;
                                {option.option || option?.option_value}
                              </div>
                            ))}
                          </Stack>
                        </Stack>

                        <Stack className="correct Option">
                          <Stack spacing={1}>
                            <strong>Correct Option:</strong>
                            {questionSelected?.options?.map((opt, i) => {
                              if (opt.is_correct === 1)
                                return (
                                  <div key={i}>
                                    {String.fromCharCode(i + 97)}) {opt?.option}{" "}
                                    &nbsp; {opt?.option_value}
                                  </div>
                                );
                            })}
                          </Stack>
                        </Stack>
                      </Stack>
                    </MathJax>
                    <Stack style={{ display: "flex", marginBottom: "1rem" }}>
                      <MathJax>
                        <Stack direction="row" spacing={3}>
                          <div style={{ display: "flex", marginTop: "1rem" }}>
                            <b>Explanation:</b>
                          </div>
                          <p
                            className="text-lg"
                            style={{
                              display: "inline",
                            }}
                            dangerouslySetInnerHTML={{
                              __html: questionSelected?.description_text,
                            }}
                          ></p>
                        </Stack>
                      </MathJax>
                    </Stack>
                  </Stack>
                ) : (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      marginTop: "3rem",
                    }}
                  >
                    {/* <CircularProgress
                      size={50}
                      style={{ marginInline: "auto" }}
                    /> */}
                  </div>
                )}
              </Stack>
            </Stack>
          </Container>
        </Page>
      )}
    </>
  );
}
